import { render, staticRenderFns } from "./FamilyDataOtherLocations.vue?vue&type=template&id=12849aec&scoped=true&"
import script from "./FamilyDataOtherLocations.vue?vue&type=script&lang=ts&"
export * from "./FamilyDataOtherLocations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12849aec",
  null
  
)

export default component.exports